import React, { ChangeEvent } from "react";
// mui
import {
    FormControl,
    Select,
    MenuItem,
    InputLabel,
    FormHelperText,
} from "@mui/material";
// hook form
import { Controller } from "react-hook-form";
type Props = {
    errorMessage: string | undefined;
    control: any;
};

const SelectApp = ({ errorMessage, control }: Props) => {
    return (
        <FormControl fullWidth error={errorMessage ? true : false}>
            <InputLabel>التطبيق</InputLabel>
            <Controller
                name="category"
                control={control}
                render={({ field }) => (
                    <Select label="التطبيق" {...field}>
                        {options.map((opt, index) => (
                            <MenuItem key={index} value={opt.key}>
                                {opt.title}
                            </MenuItem>
                        ))}
                    </Select>
                )}
            />
            {errorMessage ? (
                <FormHelperText id="app-error-msg">
                    {errorMessage}
                </FormHelperText>
            ) : (
                <></>
            )}
        </FormControl>
    );
};

export default SelectApp;
const options = [
    {
        title: "البوابة",
        key: process.env.REACT_APP_PORTAL_CAT_ID || "",
    },
    {
        title: "المتجر",
        key: process.env.REACT_APP_STORE_CAT_ID || "",
    },
];
